module.exports = __webpack_public_path__ + "img/teacher@2x.b75bb6bc.png";